import { useTranslation } from "react-i18next";
import { HeaderTextBlock, TypographyContainer } from "@/components/Typography";
import { Button } from "@/components/Button";
import { faCaretRight } from "@fortawesome/pro-solid-svg-icons";
import TeamMembersTable from "@/components/Table/TeamMembersTable";

const UserManagement = () => {
  const { t } = useTranslation();

  const renderHeaderTextBlock = () => (
    <TypographyContainer>
      <HeaderTextBlock
        align="left"
        featureText={t("settings.userManagement.header.feature")}
        descriptionTextColor="secondary"
        headingText={t("settings.userManagement.header.heading")}
        descriptionText={t("settings.userManagement.header.description")}
      />
    </TypographyContainer>
  );

  const renderAddCustomerCTA = () => (
    <div className="mt-30">
      <Button
        as="link"
        variant="link"
        to="add"
        icon={faCaretRight}
        iconPosition="end"
        iconClassName="w-20 h-20">
        {t("settings.userManagement.addTeamMemberCta")}
      </Button>
    </div>
  );

  const renderTeamMembersTable = () => <TeamMembersTable />;

  return (
    <>
      {renderHeaderTextBlock()}
      {renderAddCustomerCTA()}
      {renderTeamMembersTable()}
    </>
  );
};
export default UserManagement;
